import { createI18n } from 'vue-i18n'

const messages = {
  "en": {
    "generic": {
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "add": "Add",
      "save": "Save",
      "download": "Download",
      "close": "Close",
      "clear": "Clear",
      "actions": "Actions",
      "view": "View",
      "duplicate": "Duplicate",
      "info": "Info",
      "domain": "Domain",
      "telco": "Telco",
      "topManagement": "Top Management",
      "automotive": "Automotive",
      "energy": "Energy",
      "notAuthorized": "You are not authorized to perform this action.",
    },
    "dashboard": {
      "deleteInterview": "Delete Interview",
      "areYouSureYouWantToDeleteThisInterviewResultThisActionCannotBeUndone": "Are you sure you want to delete this interview result? This action cannot be undone.",
      "dashboard": "Dashboard",
      "viewAndAnalyzeInterviewsChartsAndInsights": "View and analyze interviews charts and insights",
      "interviewResults": "Interview Results",
      "filterByTopic": "Filter by topic",
      "topics": "Topics",
      "availableRuns": "Available Runs",
      "noRunsAvailable": "No runs available",
      "loadingRunDetails": "Loading run details...",
      "personas": "Personas:",
      "topic": "Topic:",
      "generateDashboardChartsFromThisRun": "Generate dashboard charts from this run",
      "generateDashboard": "Generate Dashboard",
      "personasList": "Personas List",
      "genderDistribution": "Gender Distribution",
      "displaysTheDistributionOfParticipantsByGender": "Displays the distribution of participants by gender",
      "likelihoodToAdhereToTopic": "Likelihood to Adhere to Topic",
      "ageDistribution": "Age Distribution",
      "incomeDistribution": "Income Distribution",
      "jobDistribution": "Job Distribution",
      "keyPointsEvaluation": "Key Points Evaluation",
      "sentimentAnalysis": "Sentiment Analysis",
      "aspectBasedSentimentAnalysisABSA": "Aspect Based Sentiment Analysis (ABSA)",
      "wordCloud": "Word Cloud",
      "mostCommonWords": "Most Common Words",
      "improvementsOverview": "Improvements Overview",
      "values": "Values",
      "sentiment": "Sentiment",
      "ageGroups": "Age Groups",
      "employmentStatus": "Employment Status",
      "incomeLevels": "Income Levels",
      "failedToLoadRunDetails": "Failed to load run details.",
      "runDeletedSuccessfully": "Run deleted successfully.",
      "failedToDeleteRun": "Failed to delete run.",
      "pleaseSelectARunBeforeGeneratingTheDashboard": "Please select a run before generating the dashboard.",
      "high": "High",
      "low": "Low",
      "moderate": "Moderate",
      "positive": "Positive",
      "neutral": "Neutral",
      "negative": "Negative",
      "likely": "Likely",
      "notLikely": "Not Likely",
      "unsure": "Unsure",
      "male": "Male",
      "female": "Female",
      "participants": "participants",
      "low2": "low",
      "mediumLow": "medium-low",
      "medium": "medium",
      "mediumHigh": "medium-high",
      "high2": "high",
      "failedToGenerateDashboardInvalidResponseFormat": "Failed to generate dashboard. Invalid response format.",
      "anErrorOccurredWhileGeneratingTheDashboard": "An error occurred while generating the dashboard.",
      "failedToLoadDataPleaseTryAgainLater": "Failed to load data. Please try again later."
    },
    "focusgroup": {
      "deleteFocusGroup": "Delete Focus Group",
      "areYouSureYouWantToDeleteThisFocusGroupThisActionCannotBeUndone": "Are you sure you want to delete this focus group? This action cannot be undone.",
      "focusGroupAnalysis": "Focus Group Analysis",
      "viewAndAnalyzeFocusGroupConversationsAndInsights": "View and analyze focus group conversations and insights",
      "focusGroups": "Focus Groups",
      "filterByTopic": "Filter by topic",
      "topics": "Topics",
      "availableSessions": "Available Sessions",
      "noFocusGroupsAvailable": "No focus groups available",
      "loadingFocusGroupDetails": "Loading focus group details...",
      "sessionFrom": "Session from",
      "personas": "Personas",
      "generalSummary": "General Summary",
      "noGeneralSummaryAvailable": "No general summary available.",
      "summary": "Summary",
      "noSummaryAvailableFor": "No summary available for",
      "persona": "persona.",
      "improvementPlan": "Improvement Plan",
      "noImprovementPlanAvailable": "No Improvement Plan Available",
      "viewConversationHistory": "View Conversation History",
      "failedToLoadCampaignsPleaseTryAgainLater": "Failed to load campaigns. Please try again later.",
      "failedToLoadPersonasPleaseTryAgainLater": "Failed to load personas. Please try again later.",
      "topicAddedSuccessfully": "Topic added successfully!",
      "failedToAddCampaignPleaseTryAgain": "Failed to add campaign. Please try again.",
      "failedToLoadFocusGroupsPleaseTryAgainLater": "Failed to load focus groups. Please try again later.",
      "failedToLoadFocusGroupDetails": "Failed to load focus group details.",
      "focusGroupDeletedSuccessfully": "Focus group deleted successfully.",
      "failedToDeleteFocusGroup": "Failed to delete focus group.",
      "failedToLoadDataPleaseTryAgainLater": "Failed to load data. Please try again later.",
      "templateBadge": "Template",
      "template": "Template:",
      "stimulusMaterials": "Stimulus materials"
    },
    "focusgroupdialog": {
      "conversationHistory": "Conversation History",
      "attachment": "Attachment:",
      "downloadImagePng": "Download image (.png)",
      "pdfPage": "PDF Page:",
      "noMessagesFoundMatching": "No messages found matching",
      "copyConversation": "Copy Conversation",
      "noResponseProvided": "No response provided",
      "step": "Step",
      "rounds": "rounds",
      "completedByFacilitator": "Completed by facilitator",
      "completedByRoundCap": "Round limit reached",
      "completedByJudgeError": "Ended early (system)",
      "completedByFixedRounds": "Ran all rounds",
      "interviewer": "Interviewer",
      "materialsShown": "Materials shown"
    },
    "generatepersonas": {
      "buildYourPersonas": "Build your Personas",
      "fillAttributesToBuildAIPoweredPersonas": "Fill attributes to build AI-powered personas",
      "fillAttributesToCreatePersona": "Fill in the persona attributes and save",
      "selectDomain": "Select Domain",
      "selectSegment": "Select Segment",
      "theSelectedSegmentDefinesTheArchetypeOfThePersona": "The selected segment defines the archetype of the persona",
      "personasAreGeneratedForTheTelcoDomainOtherDomainsComingSoon": "Personas are generated for the Telco domain. Other domains coming soon.",
      "telcoDomain": "Telco domain",
      "review": "Review",
      "generatePersona": "Generate Persona",
      "savePersona": "Save Persona",
      "personaAttributes": "Persona Attributes",
      "configureAttributes": "Configure Attributes",
      "livePreview": "Live Preview",
      "fillInTheFieldsToSeeAPreview": "Fill in the fields to see a preview",
      "reviewGeneratedPersona": "Review Generated Persona",
      "reviewSavedPersona": "Review Saved Persona",
      "saveSuccess": "Persona saved successfully.",
      "generateSuccess": "Persona generated and saved successfully.",
      "schemaLoadFailed": "Failed to load persona attributes for this domain.",
      "valueMustBeAtLeast": "Value must be at least {min}",
      "valueMustBeAtMost": "Value must be at most {max}",
      "fillRequiredAttributes": "Please fill in all required attributes before saving.",
      "unnamedPersona": "New Persona",
      "confirm": "Confirm",
    },
    "interview": {
      "interviewPersonas": "Interview Personas",
      "createAndManageInterviewScenariosWithAIPoweredPersonas": "Create and manage interview scenarios with AI-powered personas",
      "selectTopic": "Select Topic",
      "chooseATopicToGenerateInterviewQuestions": "Choose a topic to generate interview questions",
      "selectATopic": "Select a topic",
      "topics": "Topics",
      "loadingTopics": "Loading topics...",
      "addANewTopicToTheList": "Add a new topic to the list",
      "newTopic": "New Topic",
      "deleteSelectedTopic": "Delete selected topic",
      "topicAttachments": "Topic Attachments",
      "manageUploadedFiles": "Manage uploaded files",
      "addFiles": "Add Files",
      "generatedQuestions": "Generated Questions",
      "questionsAboutTheSelectedTopicThatWillBeAskedDuringTheInterviewOrFocusGroup": "Questions about the selected topic that will be asked during the interview or focus group",
      "editQuestionText": "Edit question text",
      "associatedFile": "Associated File:",
      "noFileAssociated": "No File Associated.",
      "saveChanges": "Save Changes",
      "questionsConfirmed": "Questions Confirmed",
      "confirmQuestions": "Confirm Questions",
      "generateQuestionsOrStartInterviews": "Generate questions or start interviews",
      "aBackgroundRunIsInProgressStartButtonsAreDisabledUntilItCompletes": "A background run is in progress. Start buttons are disabled until it completes.",
      "generateQuestionsForTheSelectedTopic": "Generate questions for the selected topic",
      "generateQuestions": "Generate Questions",
      "runAFocusGroupWithTheSelectedPersonas": "Run a focus group with the selected personas",
      "startFocusGroup": "Start Focus Group",
      "interviewTheSelectedPersonas": "Interview the selected personas",
      "startInterview": "Start Interview",
      "choosePersonas": "Choose Personas",
      "selectPersonasToIncludeInTheInterviewProcess": "Select personas to include in the interview process",
      "deselectAll": "Deselect All",
      "selectAll": "Select All",
      "noPersonasAvailablePleaseCheckYourConfiguration": "No personas available. Please check your configuration.",
      "topicDescription": "Topic Description",
      "detailsAboutTheSelectedTopic": "Details about the selected topic",
      "pleaseSelectATopicToViewItsDescription": "Please select a topic to view its description.",
      "deleteTopic": "Delete Topic",
      "areYouSureYouWantToDeleteThisActionThisActionCannotBeUndone": "Are you sure you want to delete this topic? This action cannot be undone.",




      "noQuestionsToConfirm": "No questions to confirm.",
      "questionsConfirmedYouCanNowStartInterviews": "Questions confirmed! You can now start interviews.",
      "failedToLoadTopicsPleaseTryAgain": "Failed to load topics. Please try again.",
      "failedToLoadPersonasPleaseTryAgain": "Failed to load personas. Please try again.",
      "topicAddedSuccessfully": "Topic added successfully!",
      "failedToAddTopicPleaseTryAgain": "Failed to add topic. Please try again.",
      "topicDeletedSuccessfully": "Topic deleted successfully.",
      "failedToDeleteTopic": "Failed to delete topic.",
      "pleaseSelectATopicFirst": "Please select a topic first.",
      "questionsGeneratedSuccessfully": "Questions generated successfully!",
      "failedToGenerateQuestionsPleaseTryAgain": "Failed to generate questions. Please try again.",
      "failedToTranslateQuestionsShowingOriginal": "Couldn't translate the questions to this language. Showing the original version instead.",
      "translatingQuestions": "Translating questions to the selected language...",
      "pleaseSelectAtLeastOnePersona": "Please select at least one persona.",
      "pleaseConfirmQuestionsFirst": "Please confirm questions first.",
      "pleaseSelectAQuestionGenerationPromptFirst": "Please select a question generation prompt first.",
      "pleaseSelectASummarizePromptFirst": "Please select a summarize prompt first.",
      "pleaseSelectAnImprovementPlanPromptFirst": "Please select an improvement plan prompt first.",
      "pleaseSelectAMeetingTemplateFirst": "Please select a meeting template first.",
      "interviewStartedRunningInBackground": "Interview started! Running in background...",
      "anotherRunIsAlreadyInProgressPleaseWait": "Another run is already in progress. Please wait.",
      "failedToStartTheInterviewPleaseTryAgain": "Failed to start the interview. Please try again.",
      "focusGroupStartedRunningInBackground": "Focus group started! Running in background...",
      "failedToStartTheFocusGroupPleaseTryAgain": "Failed to start the focus group. Please try again.",
      "runCompletedSuccessfully": "Run completed successfully!",
      "runFailed": "Run failed:",
      "failedToLoadInitialDataPleaseRefreshThePage": "Failed to load initial data. Please refresh the page.",
      "executionMode": "Execution Mode",
      "chooseHowTheSessionWillBeExecuted": "Choose how the session will be executed",
      "executionModeInterviewTitle": "Interview",
      "executionModeInterviewDescription": "AI generates questions based on the selected topic, then each persona is interviewed individually.",
      "executionModeQuestionDrivenTitle": "Question-driven Focus Group",
      "executionModeQuestionDrivenDescription": "AI generates questions based on the selected topic, then the personas discuss and provide insights.",
      "executionModeTemplateBasedTitle": "Template-based Focus Group",
      "executionModeTemplateBasedDescription": "The discussion follows a registered meeting template. Question generation is not required.",
      "aiPromptConfiguration": "AI Prompt Configuration",
      "selectATailoredPromptForGeneratingInterviewQuestions": "Select a tailored prompt to use for generating interview questions.",
      "selectTailoredPromptsForQuestionsAndInsights": "Select tailored prompts to use for generating questions and insights.",
      "generateQuestionPrompt": "Generate Question Prompt",
      "generateQuestionPromptDescription": "Define how AI should generate interview questions based on the selected topic and personas.",
      "summarizePrompt": "Summarize Prompt",
      "summarizePromptDescription": "Define how AI should summarize responses and extract key insights.",
      "improvementPlanPrompt": "Improvement Plan Prompt",
      "improvementPlanPromptDescription": "Define how AI should generate improvement recommendations based on insights.",
      "selectAPrompt": "Select a prompt",
      "templateConfiguration": "Template Configuration",
      "templateConfigurationSubtitle": "Select the meeting template and prompts to use for this focus group.",
      "meetingTemplate": "Meeting Template",
      "meetingTemplateDescription": "Select the meeting template that controls the step by step discussion flow.",
      "selectAMeetingTemplate": "Select a meeting template",
      "stimulusMaterials": "Stimulus materials",
      "stimulusMaterialsDescription": "Images (PNG, JPEG, WEBP, GIF), PDF or PowerPoint (PPTX) files that the personas and the facilitator see, in this order, in the template steps that show them. Each file is uploaded as soon as it is added: at most {maxMb} MB per file and {maxPages} pages in total, where an image counts as one page.",
      "addStimulusMaterials": "Add Files",
      "stimulusMaterialsPageCount": "{count} / {max} pages",
      "stimulusMaterialsOverLimit": "The materials have {count} pages in total; the maximum is {max}. Remove files to start the focus group.",
      "selectATemplateToAddStimulusMaterials": "Select a meeting template to add stimulus materials.",
      "templateDoesNotShowStimulusMaterials": "This template shows the materials in none of its steps, so no files can be added. To use them, turn on “Show the materials to participants” on at least one step of the template.",
      "templateHidesAddedStimulusMaterials": "This template shows the materials in none of its steps: remove the files, or choose a template that shows them, to start the focus group.",
      "uploadingStimulusMaterial": "Uploading...",
      "processingStimulusMaterial": "Processing the pages...",
      "stimulusMaterialUploadFailed": "The file could not be uploaded. Please try again.",
      "stimulusMaterialTooLarge": "The file is larger than {max} MB.",
      "stimulusMaterialsAlreadyAdded": "Already in the list, not added again: {names}",
      "stimulusMaterialsRemovedOtherDomain": "The stimulus materials were removed: they were uploaded for another domain. Upload them again for this one if needed.",
      "retryStimulusMaterial": "Retry",
      "removeStimulusMaterial": "Remove",
      "moveStimulusMaterialUp": "Move up",
      "moveStimulusMaterialDown": "Move down",
      "dragToReorder": "Drag to reorder",
      "startBlockedByFailedStimulusMaterials": "Remove or retry the stimulus materials that failed to upload.",
      "startBlockedByStimulusMaterialPages": "The stimulus materials exceed {max} pages in total.",
      "startBlockedByHiddenStimulusMaterials": "The selected template shows the stimulus materials in none of its steps.",
      "startBlockedByStimulusMaterialUploads": "Wait until the stimulus materials have finished uploading."
    },
    "interviewcampaigndialog": {
      "addNewTopic": "Add New Topic",
      "topicName": "Topic Name",
      "enterTopicName": "Enter topic name",
      "description": "Description",
      "enterTopicDescriptionMax1500Characters": "Enter topic description (max 1500 characters)",
      "submit": "Submit",
      "pleaseFillInAllFields": "Please fill in all fields."
    },
    "interviewcampaigndropdown": {
      "selectACampaign": "Select a campaign",
      "loadingCampaigns": "Loading campaigns..."
    },
    "newinterview": {
      "interviewPersonas": "Interview Personas",
      "createAndManageInterviewScenariosWithAIPoweredPersonas": "Create and manage interview scenarios with AI-powered personas",
      "selectTopic": "Select Topic",
      "chooseATopicToGenerateInterviewQuestions": "Choose a topic to generate interview questions",
      "selectATopic": "Select a topic",
      "loadingTopics": "Loading topics...",
      "newTopic": "New Topic",
      "topicAttachments": "Topic Attachments",
      "manageUploadedFilesMax5": "Manage uploaded files (max 5)",
      "addFiles": "Add Files",
      "generateQuestionsOrStartInterviews": "Generate questions or start interviews",
      "generateQuestions": "Generate Questions",
      "startFocusGroup": "Start Focus Group",
      "startInterview": "Start Interview",
      "choosePersonas": "Choose Personas",
      "selectPersonasToIncludeInTheInterviewProcess": "Select personas to include in the interview process",
      "topicDescription": "Topic Description",
      "detailsAboutTheSelectedTopic": "Details about the selected topic",
      "pleaseSelectATopicToViewItsDescription": "Please select a topic to view its description.",
      "generatedQuestions": "Generated Questions",
      "editQuestionText": "Edit question text",
      "associatedImage": "Associated Image:",
      "remove": "Remove",
      "changeImage": "Change Image",
      "addImage": "Add Image",
      "saveChanges": "Save Changes",
      "failedToLoadTopics": "Failed to load topics.",
      "failedToLoadPersonas": "Failed to load personas.",
      "pleaseSelectATopicFirst": "Please select a topic first.",
      "questionsGeneratedSuccessfully": "Questions generated successfully!",
      "failedToGenerateQuestions": "Failed to generate questions.",
      "changesSavedLocallyImplementAPICallToPersist": "Changes saved locally (implement API call to persist)."
    },
    "personagrid": {
      "personas": "Personas",
      "viewDetailedInfoAboutAllPersonas": "View detailed info about all personas",
      "hideGeneratedPersonas": "Hide Generated Personas",
      "viewGeneratedPersonas": "View Generated Personas",
      "gridView": "Grid View",
      "carouselView": "Carousel View",
      "deletePersona": "Delete Persona",
      "areYouSureYouWantToDeleteThisPersonaThisActionCannotBeUndone": "Are you sure you want to delete this persona? It will be deactivated and hidden from lists (recoverable in the database).",
      "profilePicture": "Profile Picture",
      "description": "Description",
      "income": "Income:",
      "personality": "Personality:",
      "interests": "Interests:",
      "area": "Area:",
      "segmentation": "Segmentation:",
      "country": "Country:",
      "countryFlag": "Country Flag",
      "createdIn": "Created in:",
      "energy": "Energy",
      "ageTag": "Age: {age}",
      "jobTag": "Job: {occupation}",
      "educationLevelTag": "Education level: {level}",
      "filterButton": "Filter",
      "noPersonasMatchFilters": "No personas match the selected filters. Try adjusting or clearing your filters.",
      "noGeneratedPersonas": "No personas created from Generate Personas for this domain yet."
    },
    "filtersettings": {
      "title": "Filter Settings",
      "filtersApplied": "Filters Applied",
      "noFiltersSelected": "No filters selected yet.",
      "noCustomAttributes": "No custom attributes found for this domain.",
      "or": "OR",
      "and": "AND",
      "ageRangeValue": "{min} – {max} years",
      "numberRangeValue": "{min} – {max}",
      "numberRangeValueWithUnit": "{min} – {max} {unit}",
      "selectedRange": "Selected range",
      "to": "to",
      "searchByPersonaName": "Search by persona name",
      "selectField": "Select {field}",
      "addField": "Add {field}",
      "searchField": "Search {field}",
      "selectOrSearchCountry": "Select or search country",
      "matchingProfilesFound": "{count} matching profile | {count} matching profiles",
      "load": "Load",
      "clearAll": "Clear All",
      "applyFilters": "Apply Filters",
      "saveFilterTitle": "Save Filter",
      "filterNameLabel": "Filter name",
      "loadFilterTitle": "Load Filter",
      "noSavedFilters": "No saved filters for this domain yet.",
      "invalidCountryError": "\"{countries}\" is not a valid country. Please select from the list.",
      "sectionDemographics": "Demographics",
      "sectionDomainAttributes": "Domain Attributes",
      "sectionSearch": "Search",
      "geographicArea": "Geographic Area",
      "tags": "Tags",
      "devices": "Devices",
      "genderOther": "Other",
      "civilStatusSingle": "Single",
      "civilStatusMarried": "Married",
      "civilStatusDivorced": "Divorced",
      "droppedUnavailableFields": "Some filter fields are no longer available and were skipped: {fields}"
    },
    "personamanagement": {
      "title": "Persona Management",
      "description": "View, edit, and manage all AI personas.",
      "searchLabel": "Search",
      "searchPlaceholder": "Search persona by name, job or country",
      "columnName": "Persona Name",
      "columnAge": "Age",
      "columnJob": "Job",
      "columnCountry": "Country",
      "columnCreatedAt": "Created At",
      "columnUpdatedAt": "Updated At",
      "loading": "Loading personas...",
      "noData": "No personas available for this domain.",
      "editPersona": "Edit Persona",
      "name": "Name",
      "age": "Age",
      "job": "Job",
      "country": "Country",
      "interestsPlaceholder": "Comma-separated, e.g. sport, cinema",
      "saveChanges": "Save Changes",
      "fillRequiredFields": "Fill all the required fields to continue.",
      "editSuccess": "Persona updated successfully.",
      "editError": "Failed to update persona. Please try again.",
      "deletePersona": "Delete Persona",
      "deleteConfirmMessage": "Are you sure you want to delete {name}? The persona will be deactivated and hidden from lists (recoverable in the database).",
      "deleteSuccess": "Persona deleted successfully.",
      "deleteError": "Failed to delete persona. Please try again.",
      "addDomain": "Add Domain",
      "addDomainTitle": "Add Domain",
      "domainNameLabel": "Domain Name",
      "domainNamePlaceholder": "Enter domain name",
      "domainDisplayNameLabel": "Display name (optional)",
      "domainDisplayNamePlaceholder": "e.g. Healthcare",
      "domainNameRequired": "Domain name is required.",
      "addDomainError": "Failed to create domain. Please try again.",
      "editPersonaAttributes": "Edit Persona Attributes",
      "createPersona": "Create Persona"
    },
    "personaframework": {
      "title": "Persona Framework Editor",
      "description": "Define and manage the attributes (fields) used to build personas.",
      "backToPersonaManagement": "Back to Persona Management",
      "addAttribute": "Add Attribute",
      "attributeManagement": "Attribute Management",
      "attributeManagementHint": "Manage the attributes that will be used for all personas in this domain.",
      "columnOrder": "Order",
      "columnName": "Attribute Name",
      "columnType": "Type",
      "columnRequired": "Required",
      "columnEditable": "Editable",
      "columnDeletable": "Deletable",
      "columnOptions": "Options / Details",
      "saveChanges": "Save Changes",
      "editAttribute": "Edit Attribute",
      "deleteAttribute": "Delete Attribute",
      "deleteAttributeConfirmNoValues": "Delete \"{name}\"? No personas currently have a value for it.",
      "deleteAttributeConfirmWithValues": "Delete \"{name}\"? {count} persona has a value for it. Its value will be removed (archived first so it stays recoverable). | Delete \"{name}\"? {count} personas have a value for it. Their values will be removed (archived first so they stay recoverable).",
      "deleteAttributeImpactLoading": "Checking how many personas have a value for this attribute…",
      "deleteAttributeImpactError": "Could not check how many personas are affected. Delete \"{name}\" anyway? Values will be removed from all personas in this domain (archived first so they stay recoverable).",
      "deleteAttributeSuccess": "Attribute deleted. Values were archived and removed from {count} persona. | Attribute deleted. Values were archived and removed from {count} personas.",
      "deleteAttributeSuccessNoValues": "Attribute deleted. No personas had a value for it.",
      "deleteAttributeError": "Failed to delete attribute.",
      "fieldLabel": "Display label",
      "fieldKey": "Technical key",
      "fieldType": "Attribute type",
      "fieldRequired": "Required field",
      "fieldEditable": "Editable on Edit Persona page",
      "fieldDeletable": "Can be deleted from schema",
      "minValue": "Minimum",
      "maxValue": "Maximum",
      "unit": "Unit (SI)",
      "unitHint": "Optional display unit for this number, e.g. cm, kg, years",
      "choices": "Options (comma-separated or enter each)",
      "typeTextShort": "Text",
      "typeNumber": "Number",
      "typeSingleSelect": "Single Select",
      "numberRange": "Minimum: {min}, Maximum: {max}",
      "noAttributes": "No attributes defined yet.",
      "validationRequired": "Label and key are required.",
      "validationInvalidKey": "Invalid attribute key. Use lowercase snake_case only (letters, numbers, underscores). Keys must not contain '.' or start with '$'.",
      "loadError": "Failed to load persona attributes.",
      "saveSuccess": "Persona attributes saved successfully.",
      "saveError": "Failed to save persona attributes.",
      "systemAttributeLocked": "This is a default attribute and cannot be edited or removed.",
      "attributeNotDeletable": "This attribute is marked as not deletable.",
      "duplicateOrderError": "Duplicate order value(s) found: {orders}. Each attribute must have a unique order.",
      "duplicateAliasKeyError": "\"{first}\" and \"{second}\" refer to the same attribute (for example, income and annual_income). Remove the duplicate or rename one key.",
      "invalidOrderRangeError": "Attribute order is invalid. Orders must be sequential from 1 to the total number of attributes.",
      "dragReorderHint": "Drag using the handle to reorder attributes.",
      "dragHandle": "Drag to reorder",
      "attributeCount": "{count} attributes"
    },
    "personavalidation": {
      "mustBeNumber": "Must be a valid number",
      "valueMustBeAtLeast": "Value must be at least {min}",
      "valueMustBeAtMost": "Value must be at most {max}",
    },
    "personaedit": {
      "title": "Edit Persona",
      "description": "Update this persona's attributes. Changes are saved to the existing persona.",
      "backToPersonaManagement": "Back to Persona Management",
      "notFound": "This persona could not be found. It may have been deleted.",
      "changeImage": "Change Image",
      "personaPreview": "Persona Preview",
      "unnamedPersona": "Unnamed Persona",
      "activeServicesPlaceholder": "Add a service and press enter",
      "fieldRequired": "This field is required.",
      "fields": {
        "first_name": "First Name",
        "last_name": "Last Name",
        "age": "Age",
        "country": "Country",
        "interests": "Interests",
        "marital_status": "Marital Status",
        "gender": "Gender",
        "number_of_children": "Number of Children",
        "education_level": "Education Level",
        "job_title": "Job Title",
        "annual_income": "Annual Income",
        "preferred_contact_method": "Preferred Contact Method",
        "payment_terms": "Payment Terms",
        "area": "Area",
        "current_operator": "Current Operator",
        "plan_type": "Plan Type",
        "active_services": "Active Services",
        "data_usage": "Data Usage",
        "average_monthly_spend": "Average Monthly Spend",
        "churn_propensity": "Churn Propensity"
      }
    },
    "personainfo": {
      "generatedPersona": "Generated Persona",
      "backToPersonas": "Back to Personas",
      "personalProfile": "Personal Profile",
      "demographics": "Demographics",
      "personality": "Personality",
      "personalInterests": "Personal Interests",
      "devices": "Devices",
      "telecomProfile": "Telecom Profile",
      "bigFivePersonalityProfile": "Big Five Personality Profile",
      "weekendRoutine": "Weekend Routine",
      "onlineBehavior": "Online Behavior",
      "connectionUsage": "Connection Usage",
      "transportationBehaviour": "Transportation Behaviour",
      "workPatternsAndUsage": "Work Patterns & Usage",
      "mainNeeds": "Main Needs",
      "technologyAndTools": "Technology & Tools",
      "customerStatus": "Customer Status",
      "customerEngagement": "Customer Engagement",
      "energyUsageContext": "Energy Usage Context",
      "onlineBehaviorAndEnergyEngagement": "Online Behavior & Energy Engagement",
      "characterProfile": "Character Profile"
    },
    "promptmanagement": {
      "title": "Prompt Management",
      "description": "Manage and organize prompts for interviews and focus groups.",
      "questionDriven": "Question-driven",
      "questionDrivenDescription": "Create and manage custom questions used in interviews and focus groups.",
      "templateBased": "Template-based",
      "templateBasedDescription": "Use and manage predefined templates for different purposes and scenarios.",
      "backToPromptManagement": "Back to Prompt Management",
      "newPrompt": "New Prompt",
      "editPrompt": "Edit Prompt",
      "createPrompt": "Create Prompt",
      "allTypes": "All Types",
      "promptType": "Prompt Type",
      "selectPromptType": "Select prompt type",
      "promptName": "Prompt Name",
      "enterPromptName": "Enter prompt name",
      "promptContent": "Prompt Content",
      "enterPromptContent": "Enter prompt content",
      "columnPromptName": "Prompt Name",
      "columnPreview": "Preview",
      "loadingPrompts": "Loading prompts...",
      "noPromptsAvailable": "No prompts available.",
      "deletePromptTitle": "Delete Prompt",
      "confirmDeleteNamed": "Are you sure you want to delete {name}? This action cannot be undone.",
      "promptUpdatedSuccess": "Prompt updated successfully!",
      "promptAddedSuccess": "Prompt added successfully!",
      "promptDuplicatedSuccess": "Prompt duplicated successfully!",
      "copyOfName": "Copy of {name}",
      "questionGenerationType": "Question Generation",
      "summariseType": "Summarise"
    },
    "promptmanagementquestiondriven": {
      "title": "Question-driven Focus Group Prompt Management",
      "description": "Manage prompts used for question-driven focus group execution."
    },
    "promptmanagementtemplates": {
      "title": "Template-based Focus Group Prompt Management",
      "description": "Manage meeting templates and output prompts used for Template-based Focus Group Execution",
      "newMeetingTemplate": "New Meeting Template",
      "meetingTemplateManagement": "Meeting Template Management",
      "meetingTemplateManagementHint": "Create and manage meeting templates that include step-level facilitator control prompts.",
      "availableMeetingTemplates": "Available Meeting Templates",
      "loadingTemplates": "Loading templates...",
      "noTemplatesAvailable": "No templates available.",
      "columnTemplateName": "Template Name",
      "columnLastUpdated": "Last Updated",
      "deleteTemplateTitle": "Delete Template",
      "outputPromptManagement": "Output Prompt Management",
      "outputPromptManagementHint": "Create and manage output prompts used in Template-based Focus Groups.",
      "backToTemplateList": "Back to Template List",
      "editTemplate": "Edit Template",
      "notes": "Notes",
      "templateSteps": "Template Steps",
      "promptText": "Prompt Text",
      "noStepsView": "No steps defined for this template.",
      "editMeetingTemplate": "Edit Meeting Template",
      "basicInformation": "Basic Information",
      "enterTemplateName": "Enter template name",
      "optionalLabel": "(optional)",
      "enterNotes": "Enter notes",
      "templateStepsHint": "Define the order and prompts for each step. Prompts will be applied separately during the focus group.",
      "addStep": "Add Step",
      "stepName": "Step Name",
      "enterStepName": "Enter step name",
      "enterPromptText": "Enter prompt text",
      "noStepsEdit": "No steps defined yet.",
      "atLeastOneStepRequired": "At least one step is required before saving.",
      "fillRequiredFieldsStar": "Fill the required fields indicated in * to continue.",
      "saveTemplate": "Save Template",
      "deleteStepTitle": "Delete Step",
      "deleteStepConfirm": "Are you sure you want to delete step {order}? This action cannot be undone.",
      "deleteStepConfirmNamed": "Are you sure you want to delete step {order} — \"{name}\"? This action cannot be undone.",
      "leavePageTitle": "Leave page?",
      "leavePageConfirm": "You are being directed to the Template-based prompt management page. Are you sure you want to quit? Changes will not be saved.",
      "stay": "Stay",
      "leave": "Leave",
      "templateSavedSuccess": "Template saved successfully!",
      "showAttachment": "Show the materials to participants",
      "stimulusMaterialHelp": "When a focus group is started with stimulus materials (images, PDF or PowerPoint files), this switch decides whether the personas and the facilitator see all of them during the step.",
      "stimulusMaterialHelpBias": "Turn it off in warm-up or spontaneous-question steps: seeing the materials influences the answers.",
      "stimulusMaterialHelpCost": "Every page of the materials is sent to the model on every call of the steps that show them, so each of those steps costs more.",
      "attachmentShown": "Materials shown",
      "attachmentHidden": "Materials hidden"
    },
    "attachmentpreview": {
      "kindImage": "Image",
      "kindPdf": "PDF",
      "kindPptx": "PowerPoint",
      "pageCount": "{count} page | {count} pages",
      "page": "Page {page}",
      "openPage": "Open page {page} in a new tab",
      "loadingPreview": "Loading preview...",
      "previewUnavailable": "Preview not available.",
      "previewUnavailableWithReason": "Preview not available: {reason}",
      "materialPosition": "Material {position} of {total}: {name}"
    },
    "sidebar": {
      "personas": "Personas",
      "chat": "Chat",
      "interviewPersonas": "Interview Personas",
      "focusGroup": "Focus Group",
      "dashboard": "Dashboard",
      "generatePersonas": "Generate Personas",
      "personaManagement": "Persona Management",
      "promptManagement": "Prompt Management"
    },
    "snacks": {
      "downloaded": "Downloaded",
      "formatFileNotSupportedAllowedFormatJpgPngJpegPptx": "Format File not supported. Allowed format: .jpg, .png, .jpeg, .pptx"
    },
    "chat": {
      "confirmDeletion": "Confirm Deletion",
      "areYouSureYouWantToDeleteThisConversationThisActionCannotBeUndone": "Are you sure you want to delete this conversation? This action cannot be undone.",
      "chatWithPersonas": "Chat with Personas",
      "personaSelection": "Persona Selection",
      "conversations": "Conversations",
      "noConversationsYet": "No conversations yet",
      "selectAPersonaAndStartChatting": "Select a persona and start chatting",
      "loadingConversations": "Loading conversations...",
      "selectAPersona": "Select a Persona",
      "startANewConversation": "Start a new conversation",
      "noConversationSelected": "No conversation selected",
      "noMessagesYet": "No messages yet",
      "startAConversationBySendingAMessage": "Start a conversation by sending a message",
      "page": "page",
      "slide": "slide",
      "typeYourMessageHere": "Type your message here...",
      "pleaseSelectAPersonaToStartChatting": "Please select a persona to start chatting",
      "conversationDeletedSuccessfully": "Conversation deleted successfully.",
      "failedToDeleteConversation": "Failed to delete conversation.",
      "failedToLoadConversations": "Failed to load conversations.",
      "failedToLoadPersonas": "Failed to load personas.",
      "failedToLoadConversationMessages": "Failed to load conversation messages.",
      "pleaseSelectAPersona": "Please select a persona.",
      "pleaseEnterAQuestion": "Please enter a question.",
      "noResponse": "No response.",
      "failedToGetAResponse": "Failed to get a response.",
      "failedToGetResponseFromPersona": "Failed to get response from persona.",
      "failedToGenerateANewThreadID": "Failed to generate a new thread ID.",
      "failedToLoadDataPleaseTryAgainLater": "Failed to load data. Please try again later."
    },
    "personaFields": {
      "age": "Age",
      "gender": "Gender",
      "occupation": "Occupation",
      "civil_status": "Civil Status",
      "geographic_area_of_residence": "Geographic Area of Residence",
      "qualification": "Qualification",
      "income": "Income",
      "segments": "Segments",
      "segmentation": "Segmentation",
      "country": "Country",
      "firstName": "First name",
      "lastName": "Last name",
      "marital_status": "Marital",
      "number_of_children": "Number of children",
      "education_level": "Education level",
      "job_title": "Job title",
      "annual_income": "Annual income",
      "preferred_contact_method": "Preferred contact method",
      "payment_terms": "Payment terms",
      "area": "Area",
      "current_operator": "Current operator",
      "plan_type": "Plan type",
      "active_services": "Active services",
      "data_usage": "Data usage",
      "average_monthly_spend": "Average Monthly Spend",
      "churn_propensity": "Churn propensity"
    },
    "authentication": {
      "register": "Register",
      "createYourSocialSimulationAccount": "Create your Social Simulation account",
      "email": "Email",
      "username": "Username",
      "password": "Password",
      "confirmPassword": "Confirm Password",
      "alreadyHaveAnAccount": "Already have an account?",
      "login": "Login",
      "accessSocialSimulation": "Access Social Simulation Platform",
      "dontHaveAnAccount": "Don't have an account?",
      "logout": "Logout",
      "fieldIsRequired": "Field is required",
      "invalidEmail": "Invalid email",
      "usernameMustBeAtLeast3Characters": "Username must be at least 3 characters",
      "passwordMustBeAtLeast8Characters": "Password must be at least 8 characters",
      "passwordsDoNotMatch": "Passwords do not match",
      "registrationCompletedSuccessfully": "Registration completed successfully",
      "registrationFailedPleaseTryAgain": "Registration failed. Please try again.",
      "loginFailedPleaseCheckYourCredentials": "Login failed. Please check your credentials.",
      "socialSimulationPlatform": "Social Simulation Platform",
      "aipoweredFocusGroupFacilitationToUnlockDeeperInsights": "AI-powered focus group facilitation to unlock deeper insights."
    }
  },
  "ja": {
    "generic": {
      "cancel": "キャンセル",
      "delete": "削除",
      "edit": "編集",
      "add": "追加",
      "save": "保存",
      "download": "ダウンロード",
      "close": "閉じる",
      "clear": "クリア",
      "actions": "操作",
      "view": "表示",
      "duplicate": "複製",
      "info": "情報",
      "domain": "ドメイン",
      "telco": "通信",
      "topManagement": "経営層",
      "automotive": "自動車",
      "energy": "エネルギー",
      "notAuthorized": "この操作を行う権限がありません。",
    },
    "dashboard": {
      "deleteInterview": "インタビューの削除",
      "areYouSureYouWantToDeleteThisInterviewResultThisActionCannotBeUndone": "このインタビュー結果を削除してもよろしいですか？この操作は取り消せません。",
      "dashboard": "ダッシュボード",
      "viewAndAnalyzeInterviewsChartsAndInsights": "インタビューのグラフとインサイトを確認・分析します",
      "interviewResults": "インタビュー結果",
      "filterByTopic": "トピックで絞り込み",
      "topics": "トピック",
      "availableRuns": "利用可能な実行結果",
      "noRunsAvailable": "利用可能な実行結果はありません",
      "loadingRunDetails": "実行結果の詳細を読み込んでいます...",
      "personas": "ペルソナ:",
      "topic": "トピック:",
      "generateDashboardChartsFromThisRun": "この実行結果からダッシュボードのグラフを生成します",
      "generateDashboard": "ダッシュボードを生成",
      "personasList": "ペルソナ一覧",
      "genderDistribution": "性別分布",
      "displaysTheDistributionOfParticipantsByGender": "参加者の性別分布を表示します",
      "likelihoodToAdhereToTopic": "トピックへの適合度",
      "ageDistribution": "年齢分布",
      "incomeDistribution": "収入分布",
      "jobDistribution": "職業分布",
      "keyPointsEvaluation": "キーポイント評価",
      "sentimentAnalysis": "感情分析",
      "aspectBasedSentimentAnalysisABSA": "アスペクトベース感情分析（ABSA）",
      "wordCloud": "ワードクラウド",
      "mostCommonWords": "頻出ワード",
      "improvementsOverview": "改善点の概要",
      "values": "価値観",
      "sentiment": "感情",
      "ageGroups": "年齢層",
      "employmentStatus": "雇用状況",
      "incomeLevels": "収入レベル",
      "failedToLoadRunDetails": "実行結果の詳細を読み込めませんでした。",
      "runDeletedSuccessfully": "実行結果を削除しました。",
      "failedToDeleteRun": "実行結果を削除できませんでした。",
      "pleaseSelectARunBeforeGeneratingTheDashboard": "ダッシュボードを生成する前に、実行結果を選択してください。",
      "high": "高",
      "low": "低",
      "moderate": "中",
      "positive": "ポジティブ",
      "neutral": "ニュートラル",
      "negative": "ネガティブ",
      "likely": "高",
      "notLikely": "低",
      "unsure": "不明",
      "male": "男性",
      "female": "女性",
      "participants": "参加者",
      "low2": "低",
      "mediumLow": "やや低",
      "medium": "中",
      "mediumHigh": "やや高",
      "high2": "高",
      "failedToGenerateDashboardInvalidResponseFormat": "ダッシュボードを生成できませんでした。無効なレスポンスフォーマットです。",
      "anErrorOccurredWhileGeneratingTheDashboard": "ダッシュボードの生成中にエラーが発生しました。",
      "failedToLoadDataPleaseTryAgainLater": "データを読み込めませんでした。後でもう一度お試しください。"
    },
    "focusgroup": {
      "deleteFocusGroup": "フォーカスグループを削除",
      "areYouSureYouWantToDeleteThisFocusGroupThisActionCannotBeUndone": "このフォーカスグループを削除してもよろしいですか？この操作は取り消せません。",
      "focusGroupAnalysis": "フォーカスグループ分析",
      "viewAndAnalyzeFocusGroupConversationsAndInsights": "フォーカスグループの会話とインサイトを確認・分析します",
      "focusGroups": "フォーカスグループ",
      "filterByTopic": "トピックで絞り込み",
      "topics": "トピック",
      "availableSessions": "利用可能なセッション",
      "noFocusGroupsAvailable": "利用可能なフォーカスグループはありません",
      "loadingFocusGroupDetails": "フォーカスグループの詳細を読み込んでいます…",
      "sessionFrom": "セッション日時",
      "personas": "ペルソナ",
      "generalSummary": "全体サマリー",
      "noGeneralSummaryAvailable": "利用可能な全体サマリーはありません。",
      "summary": "サマリー",
      "noSummaryAvailableFor": "次のサマリーはありません:",
      "persona": "ペルソナ",
      "improvementPlan": "改善計画",
      "noImprovementPlanAvailable": "利用可能な改善計画はありません",
      "viewConversationHistory": "会話履歴を表示",
      "failedToLoadCampaignsPleaseTryAgainLater": "キャンペーンを読み込めませんでした。後でもう一度お試しください。",
      "failedToLoadPersonasPleaseTryAgainLater": "ペルソナを読み込めませんでした。後でもう一度お試しください。",
      "topicAddedSuccessfully": "トピックを追加しました。",
      "failedToAddCampaignPleaseTryAgain": "キャンペーンを追加できませんでした。もう一度お試しください。",
      "failedToLoadFocusGroupsPleaseTryAgainLater": "フォーカスグループを読み込めませんでした。後でもう一度お試しください。",
      "failedToLoadFocusGroupDetails": "フォーカスグループの詳細を読み込めませんでした。",
      "focusGroupDeletedSuccessfully": "フォーカスグループを削除しました。",
      "failedToDeleteFocusGroup": "フォーカスグループを削除できませんでした。",
      "failedToLoadDataPleaseTryAgainLater": "データを読み込めませんでした。後でもう一度お試しください。",
      "templateBadge": "テンプレート",
      "template": "テンプレート:",
      "stimulusMaterials": "提示資料"
    },
    "focusgroupdialog": {
      "conversationHistory": "会話履歴",
      "attachment": "添付ファイル:",
      "downloadImagePng": "画像をダウンロード（.png）",
      "pdfPage": "PDFページ:",
      "noMessagesFoundMatching": "一致するメッセージはありません",
      "copyConversation": "会話をコピー",
      "noResponseProvided": "応答がありません",
      "step": "ステップ",
      "rounds": "ラウンド",
      "completedByFacilitator": "ファシリテーターにより完了",
      "completedByRoundCap": "ラウンド上限に到達",
      "completedByJudgeError": "システムにより早期終了",
      "completedByFixedRounds": "既定のラウンドを実行",
      "interviewer": "インタビュアー",
      "materialsShown": "資料提示あり"
    },
    "generatepersonas": {
      "buildYourPersonas": "ペルソナ作成",
      "fillAttributesToBuildAIPoweredPersonas": "属性を入力してAIペルソナを作成します",
      "fillAttributesToCreatePersona": "ペルソナ属性を入力して保存します",
      "selectDomain": "ドメインを選択",
      "selectSegment": "セグメントを選択",
      "theSelectedSegmentDefinesTheArchetypeOfThePersona": "選択したセグメントによって、ペルソナの基本タイプが決まります",
      "personasAreGeneratedForTheTelcoDomainOtherDomainsComingSoon": "ペルソナは通信ドメイン向けに生成されます。他のドメインは今後対応予定です。",
      "telcoDomain": "通信ドメイン",
      "review": "確認",
      "generatePersona": "ペルソナを生成",
      "savePersona": "ペルソナを保存",
      "personaAttributes": "ペルソナ属性",
      "configureAttributes": "属性を設定",
      "livePreview": "プレビュー",
      "fillInTheFieldsToSeeAPreview": "項目を入力するとプレビューが表示されます",
      "reviewGeneratedPersona": "生成されたペルソナを確認",
      "reviewSavedPersona": "保存されたペルソナを確認",
      "saveSuccess": "ペルソナを保存しました。",
      "generateSuccess": "ペルソナを生成して保存しました。",
      "schemaLoadFailed": "このドメインのペルソナ属性を読み込めませんでした。",
      "valueMustBeAtLeast": "{min}以上の値を入力してください",
      "valueMustBeAtMost": "{max}以下の値を入力してください",
      "fillRequiredAttributes": "保存する前に、必須属性をすべて入力してください。",
      "unnamedPersona": "新規ペルソナ",
      "confirm": "確定",
    },
    "interview": {
      "interviewPersonas": "ペルソナインタビュー",
      "createAndManageInterviewScenariosWithAIPoweredPersonas": "AIペルソナを使ったインタビューシナリオを作成・管理します",
      "selectTopic": "トピックを選択",
      "chooseATopicToGenerateInterviewQuestions": "インタビュー質問を生成するトピックを選択してください",
      "selectATopic": "トピックを選択",
      "topics": "トピック",
      "loadingTopics": "トピックを読み込んでいます…",
      "addANewTopicToTheList": "新しいトピックをリストに追加",
      "newTopic": "新規トピック",
      "deleteSelectedTopic": "選択したトピックを削除",
      "topicAttachments": "添付ファイル",
      "manageUploadedFiles": "アップロード済みファイルを管理",
      "addFiles": "ファイルを追加",
      "generatedQuestions": "生成された質問",
      "questionsAboutTheSelectedTopicThatWillBeAskedDuringTheInterviewOrFocusGroup": "インタビューまたはフォーカスグループで使用する、選択中トピックに関する質問",
      "editQuestionText": "質問文を編集",
      "associatedFile": "関連ファイル:",
      "noFileAssociated": "関連ファイルはありません。",
      "saveChanges": "変更を保存",
      "questionsConfirmed": "質問が確定されました",
      "confirmQuestions": "質問を確定",
      "generateQuestionsOrStartInterviews": "質問を生成するかインタビューを開始します",
      "aBackgroundRunIsInProgressStartButtonsAreDisabledUntilItCompletes": "バックグラウンド実行中です。完了するまで開始ボタンは使用できません。",
      "generateQuestionsForTheSelectedTopic": "選択したトピックの質問を生成します",
      "generateQuestions": "質問を生成",
      "runAFocusGroupWithTheSelectedPersonas": "選択したペルソナでフォーカスグループを実行します",
      "startFocusGroup": "フォーカスグループを開始",
      "interviewTheSelectedPersonas": "選択したペルソナにインタビューします",
      "startInterview": "インタビューを開始",
      "choosePersonas": "ペルソナを選択",
      "selectPersonasToIncludeInTheInterviewProcess": "インタビューに参加するペルソナを選択してください",
      "deselectAll": "すべて選択解除",
      "selectAll": "すべて選択",
      "noPersonasAvailablePleaseCheckYourConfiguration": "利用可能なペルソナはありません。設定を確認してください。",
      "topicDescription": "トピックの説明",
      "detailsAboutTheSelectedTopic": "選択したトピックの詳細",
      "pleaseSelectATopicToViewItsDescription": "説明を表示するにはトピックを選択してください。",
      "deleteTopic": "トピックを削除",
      "areYouSureYouWantToDeleteThisActionThisActionCannotBeUndone": "このトピックを削除してもよろしいですか？この操作は取り消せません。",
      "noQuestionsToConfirm": "確定する質問がありません。",
      "questionsConfirmedYouCanNowStartInterviews": "質問を確定しました。インタビューを開始できます。",
      "failedToLoadTopicsPleaseTryAgain": "トピックを読み込めませんでした。もう一度お試しください。",
      "failedToLoadPersonasPleaseTryAgain": "ペルソナを読み込めませんでした。もう一度お試しください。",
      "topicAddedSuccessfully": "トピックを追加しました。",
      "failedToAddTopicPleaseTryAgain": "トピックを追加できませんでした。もう一度お試しください。",
      "topicDeletedSuccessfully": "トピックを削除しました。",
      "failedToDeleteTopic": "トピックを削除できませんでした。",
      "pleaseSelectATopicFirst": "先にトピックを選択してください。",
      "questionsGeneratedSuccessfully": "質問を生成しました。",
      "failedToGenerateQuestionsPleaseTryAgain": "質問を生成できませんでした。もう一度お試しください。",
      "failedToTranslateQuestionsShowingOriginal": "質問をこの言語に翻訳できませんでした。元の言語で表示しています。",
      "translatingQuestions": "選択した言語に質問を翻訳しています…",
      "pleaseSelectAtLeastOnePersona": "参加ペルソナを1つ以上選択してください。",
      "pleaseConfirmQuestionsFirst": "先に質問を確定してください。",
      "pleaseSelectAQuestionGenerationPromptFirst": "先に質問生成プロンプトを選択してください。",
      "pleaseSelectASummarizePromptFirst": "先に要約プロンプトを選択してください。",
      "pleaseSelectAnImprovementPlanPromptFirst": "先に改善計画プロンプトを選択してください。",
      "pleaseSelectAMeetingTemplateFirst": "先にミーティングテンプレートを選択してください。",
      "interviewStartedRunningInBackground": "インタビューを開始しました。バックグラウンドで実行中です…",
      "anotherRunIsAlreadyInProgressPleaseWait": "別の実行がすでに進行中です。しばらくお待ちください。",
      "failedToStartTheInterviewPleaseTryAgain": "インタビューを開始できませんでした。もう一度お試しください。",
      "focusGroupStartedRunningInBackground": "フォーカスグループを開始しました。バックグラウンドで実行中です…",
      "failedToStartTheFocusGroupPleaseTryAgain": "フォーカスグループを開始できませんでした。もう一度お試しください。",
      "runCompletedSuccessfully": "実行が完了しました。",
      "runFailed": "実行に失敗しました:",
      "failedToLoadInitialDataPleaseRefreshThePage": "初期データを読み込めませんでした。ページを更新してください。",
      "executionMode": "実行モード",
      "chooseHowTheSessionWillBeExecuted": "セッションの実行方法を選択してください",
      "executionModeInterviewTitle": "インタビュー",
      "executionModeInterviewDescription": "AIが選択したトピックから質問を生成し、各ペルソナに個別インタビューを行います。",
      "executionModeQuestionDrivenTitle": "質問ベースのフォーカスグループ",
      "executionModeQuestionDrivenDescription": "AIが選択したトピックから質問を生成し、ペルソナが議論してインサイトを提供します。",
      "executionModeTemplateBasedTitle": "テンプレートベースのフォーカスグループ",
      "executionModeTemplateBasedDescription": "登録済みのミーティングテンプレートに沿って議論が進みます。質問生成は不要です。",
      "aiPromptConfiguration": "AIプロンプト設定",
      "selectATailoredPromptForGeneratingInterviewQuestions": "インタビュー質問の生成に使用するプロンプトを選択してください。",
      "selectTailoredPromptsForQuestionsAndInsights": "質問とインサイトの生成に使用するプロンプトを選択してください。",
      "generateQuestionPrompt": "質問生成プロンプト",
      "generateQuestionPromptDescription": "選択したトピックとペルソナに基づいて、AIがどのように質問を生成するかを定義します。",
      "summarizePrompt": "要約プロンプト",
      "summarizePromptDescription": "AIがどのように回答を要約し、重要なインサイトを抽出するかを定義します。",
      "improvementPlanPrompt": "改善計画プロンプト",
      "improvementPlanPromptDescription": "AIがインサイトに基づいてどのように改善提案を作成するかを定義します。",
      "selectAPrompt": "プロンプトを選択",
      "templateConfiguration": "テンプレート設定",
      "templateConfigurationSubtitle": "このフォーカスグループで使用するミーティングテンプレートとプロンプトを選択してください。",
      "meetingTemplate": "ミーティングテンプレート",
      "meetingTemplateDescription": "ステップごとの議論の流れを制御するミーティングテンプレートを選択してください。",
      "selectAMeetingTemplate": "ミーティングテンプレートを選択",
      "stimulusMaterials": "提示資料",
      "stimulusMaterialsDescription": "テンプレートのうち資料を表示するステップで、この順番でペルソナとファシリテーターに提示する画像（PNG、JPEG、WEBP、GIF）、PDF、またはPowerPoint（PPTX）ファイル。各ファイルは追加した時点でアップロードされます。1ファイルあたり最大 {maxMb} MB、合計最大 {maxPages} ページです（画像は1ページとして数えます）。",
      "addStimulusMaterials": "ファイルを追加",
      "stimulusMaterialsPageCount": "{count} / {max} ページ",
      "stimulusMaterialsOverLimit": "資料は合計 {count} ページで、上限の {max} ページを超えています。フォーカスグループを開始するには、ファイルを削除してください。",
      "selectATemplateToAddStimulusMaterials": "提示資料を追加するには、ミーティングテンプレートを選択してください。",
      "templateDoesNotShowStimulusMaterials": "このテンプレートには資料を表示するステップがないため、ファイルを追加できません。使用するには、テンプレートの少なくとも1つのステップで「参加者に資料を表示」をオンにしてください。",
      "templateHidesAddedStimulusMaterials": "このテンプレートには資料を表示するステップがありません。フォーカスグループを開始するには、ファイルを削除するか、資料を表示するテンプレートを選択してください。",
      "uploadingStimulusMaterial": "アップロード中...",
      "processingStimulusMaterial": "ページを処理中...",
      "stimulusMaterialUploadFailed": "ファイルをアップロードできませんでした。もう一度お試しください。",
      "stimulusMaterialTooLarge": "ファイルが {max} MB を超えています。",
      "stimulusMaterialsAlreadyAdded": "すでにリストにあるため追加しませんでした: {names}",
      "stimulusMaterialsRemovedOtherDomain": "提示資料は別のドメイン用にアップロードされていたため、削除しました。必要に応じて、このドメイン用に再度アップロードしてください。",
      "retryStimulusMaterial": "再試行",
      "removeStimulusMaterial": "削除",
      "moveStimulusMaterialUp": "上へ移動",
      "moveStimulusMaterialDown": "下へ移動",
      "dragToReorder": "ドラッグして並べ替え",
      "startBlockedByFailedStimulusMaterials": "アップロードに失敗した提示資料を削除するか、再試行してください。",
      "startBlockedByStimulusMaterialPages": "提示資料が合計 {max} ページを超えています。",
      "startBlockedByHiddenStimulusMaterials": "選択したテンプレートには提示資料を表示するステップがありません。",
      "startBlockedByStimulusMaterialUploads": "提示資料のアップロードが完了するまでお待ちください。"
    },
    "interviewcampaigndialog": {
      "addNewTopic": "新規トピックを追加",
      "topicName": "トピック名",
      "enterTopicName": "トピック名を入力",
      "description": "説明",
      "enterTopicDescriptionMax1500Characters": "トピックの説明を入力（最大1500文字）",
      "submit": "決定",
      "pleaseFillInAllFields": "すべての項目を入力してください。"
    },
    "interviewcampaigndropdown": {
      "selectACampaign": "キャンペーンを選択",
      "loadingCampaigns": "キャンペーンを読み込んでいます…"
    },
    "newinterview": {
      "interviewPersonas": "ペルソナインタビュー",
      "createAndManageInterviewScenariosWithAIPoweredPersonas": "AIペルソナを使ったインタビューシナリオを作成・管理します",
      "selectTopic": "トピックを選択",
      "chooseATopicToGenerateInterviewQuestions": "インタビュー質問を生成するトピックを選択してください",
      "selectATopic": "トピックを選択",
      "loadingTopics": "トピックを読み込んでいます…",
      "newTopic": "新規トピック",
      "topicAttachments": "トピックの添付ファイル",
      "manageUploadedFilesMax5": "アップロード済みファイルを管理（最大5件）",
      "addFiles": "ファイルを追加",
      "generateQuestionsOrStartInterviews": "質問を生成するか、インタビューを開始します",
      "generateQuestions": "質問を生成",
      "startFocusGroup": "フォーカスグループを開始",
      "startInterview": "インタビューを開始",
      "choosePersonas": "ペルソナを選択",
      "selectPersonasToIncludeInTheInterviewProcess": "インタビューに参加するペルソナを選択してください",
      "topicDescription": "トピックの説明",
      "detailsAboutTheSelectedTopic": "選択したトピックの詳細",
      "pleaseSelectATopicToViewItsDescription": "説明を表示するにはトピックを選択してください。",
      "generatedQuestions": "生成された質問",
      "editQuestionText": "質問文を編集",
      "associatedImage": "関連画像:",
      "remove": "削除",
      "changeImage": "画像を変更",
      "addImage": "画像を追加",
      "saveChanges": "変更を保存",
      "failedToLoadTopics": "トピックを読み込めませんでした。",
      "failedToLoadPersonas": "ペルソナを読み込めませんでした。",
      "pleaseSelectATopicFirst": "先にトピックを選択してください。",
      "questionsGeneratedSuccessfully": "質問を生成しました。",
      "failedToGenerateQuestions": "質問を生成できませんでした。",
      "changesSavedLocallyImplementAPICallToPersist": "変更はローカルに保存されました（永続化にはAPI連携の実装が必要です）。"
    },
    "personagrid": {
      "personas": "ペルソナ",
      "viewDetailedInfoAboutAllPersonas": "すべてのペルソナの詳細情報を表示します",
      "hideGeneratedPersonas": "生成したペルソナを非表示",
      "viewGeneratedPersonas": "生成したペルソナを表示",
      "gridView": "タイル表示",
      "carouselView": "横スクロール表示",
      "deletePersona": "ペルソナを削除",
      "areYouSureYouWantToDeleteThisPersonaThisActionCannotBeUndone": "このペルソナを削除してもよろしいですか？無効化され一覧から非表示になります（データベース上では復元可能です）。",
      "profilePicture": "プロフィール画像",
      "description": "説明",
      "income": "収入:",
      "personality": "性格:",
      "interests": "関心:",
      "area": "地域:",
      "segmentation": "セグメント:",
      "country": "国:",
      "countryFlag": "国旗",
      "createdIn": "作成日時:",
      "energy": "エネルギー",
      "ageTag": "年齢: {age}",
      "jobTag": "職業: {occupation}",
      "educationLevelTag": "学歴: {level}",
      "filterButton": "フィルター",
      "noPersonasMatchFilters": "選択したフィルターに一致するペルソナがありません。フィルターを調整するかクリアしてください。",
      "noGeneratedPersonas": "このドメインには「ペルソナ作成」から保存したペルソナがありません。"
    },
    "filtersettings": {
      "title": "フィルター設定",
      "filtersApplied": "適用中のフィルター",
      "noFiltersSelected": "フィルターはまだ選択されていません。",
      "noCustomAttributes": "このドメインにはカスタム属性が見つかりません。",
      "or": "または",
      "and": "かつ",
      "ageRangeValue": "{min}〜{max}歳",
      "numberRangeValue": "{min}〜{max}",
      "numberRangeValueWithUnit": "{min}〜{max} {unit}",
      "selectedRange": "選択範囲",
      "to": "〜",
      "searchByPersonaName": "ペルソナ名で検索",
      "selectField": "{field}を選択",
      "addField": "{field}を追加",
      "searchField": "{field}を検索",
      "selectOrSearchCountry": "国を選択または検索",
      "matchingProfilesFound": "{count} 件のペルソナが該当します",
      "load": "読み込み",
      "clearAll": "すべてクリア",
      "applyFilters": "フィルターを適用",
      "saveFilterTitle": "フィルターを保存",
      "filterNameLabel": "フィルター名",
      "loadFilterTitle": "フィルターを読み込み",
      "noSavedFilters": "このドメインに保存されたフィルターはまだありません。",
      "invalidCountryError": "「{countries}」は有効な国ではありません。リストから選択してください。",
      "sectionDemographics": "基本属性",
      "sectionDomainAttributes": "ドメイン属性",
      "sectionSearch": "検索",
      "geographicArea": "居住地域",
      "tags": "タグ",
      "devices": "デバイス",
      "genderOther": "その他",
      "civilStatusSingle": "独身",
      "civilStatusMarried": "既婚",
      "civilStatusDivorced": "離婚",
      "droppedUnavailableFields": "利用できないフィルター項目はスキップされました: {fields}"
    },
    "personamanagement": {
      "title": "ペルソナ管理",
      "description": "すべてのAIペルソナを表示、編集、管理します。",
      "searchLabel": "検索",
      "searchPlaceholder": "名前、職業、国でペルソナを検索",
      "columnName": "ペルソナ名",
      "columnAge": "年齢",
      "columnJob": "職業",
      "columnCountry": "国",
      "columnCreatedAt": "作成日時",
      "columnUpdatedAt": "更新日時",
      "loading": "ペルソナを読み込み中...",
      "noData": "このドメインには利用可能なペルソナがありません。",
      "editPersona": "ペルソナを編集",
      "name": "名前",
      "age": "年齢",
      "job": "職業",
      "country": "国",
      "interestsPlaceholder": "カンマ区切り（例：スポーツ、映画）",
      "saveChanges": "変更を保存",
      "fillRequiredFields": "続行するには必須項目をすべて入力してください。",
      "editSuccess": "ペルソナを更新しました。",
      "editError": "ペルソナの更新に失敗しました。もう一度お試しください。",
      "deletePersona": "ペルソナを削除",
      "deleteConfirmMessage": "{name} を削除してもよろしいですか？ペルソナは無効化され一覧から非表示になります（データベース上では復元可能です）。",
      "deleteSuccess": "ペルソナを削除しました。",
      "deleteError": "ペルソナの削除に失敗しました。もう一度お試しください。",
      "addDomain": "ドメインを追加",
      "addDomainTitle": "ドメインを追加",
      "domainNameLabel": "ドメイン名",
      "domainNamePlaceholder": "ドメイン名を入力",
      "domainDisplayNameLabel": "表示名（任意）",
      "domainDisplayNamePlaceholder": "例: ヘルスケア",
      "domainNameRequired": "ドメイン名は必須です。",
      "addDomainError": "ドメインの作成に失敗しました。もう一度お試しください。",
      "editPersonaAttributes": "ペルソナ属性を編集",
      "createPersona": "ペルソナを作成"
    },
    "personaframework": {
      "title": "ペルソナフレームワークエディター",
      "description": "ペルソナ構築に使用する属性（フィールド）を定義・管理します。",
      "backToPersonaManagement": "ペルソナ管理に戻る",
      "addAttribute": "属性を追加",
      "attributeManagement": "属性管理",
      "attributeManagementHint": "このドメインのすべてのペルソナで使用する属性を管理します。",
      "columnOrder": "順序",
      "columnName": "属性名",
      "columnType": "タイプ",
      "columnRequired": "必須",
      "columnEditable": "編集可能",
      "columnDeletable": "削除可能",
      "columnOptions": "オプション / 詳細",
      "saveChanges": "変更を保存",
      "editAttribute": "属性を編集",
      "deleteAttribute": "属性を削除",
      "deleteAttributeConfirmNoValues": "「{name}」を削除しますか？現在、この属性に値を持つペルソナはありません。",
      "deleteAttributeConfirmWithValues": "「{name}」を削除しますか？{count} 件のペルソナが値を持っています。値は削除されます（先にアーカイブされ、復元可能です）。 | 「{name}」を削除しますか？{count} 件のペルソナが値を持っています。値は削除されます（先にアーカイブされ、復元可能です）。",
      "deleteAttributeImpactLoading": "この属性に値を持つペルソナ数を確認しています…",
      "deleteAttributeImpactError": "影響を受けるペルソナ数を確認できませんでした。「{name}」を削除しますか？このドメインの全ペルソナから値が削除されます（先にアーカイブされ、復元可能です）。",
      "deleteAttributeSuccess": "属性を削除しました。{count} 件のペルソナから値をアーカイブして除去しました。 | 属性を削除しました。{count} 件のペルソナから値をアーカイブして除去しました。",
      "deleteAttributeSuccessNoValues": "属性を削除しました。値を持つペルソナはありませんでした。",
      "deleteAttributeError": "属性の削除に失敗しました。",
      "fieldLabel": "表示ラベル",
      "fieldKey": "技術キー",
      "fieldType": "属性タイプ",
      "fieldRequired": "必須フィールド",
      "fieldEditable": "ペルソナ編集ページで編集可能",
      "fieldDeletable": "スキーマから削除可能",
      "minValue": "最小値",
      "maxValue": "最大値",
      "unit": "単位（SI）",
      "unitHint": "数値の表示単位（任意）。例: cm、kg、years",
      "choices": "選択肢",
      "typeTextShort": "テキスト",
      "typeNumber": "数値",
      "typeSingleSelect": "単一選択",
      "numberRange": "最小：{min}、最大：{max}",
      "noAttributes": "属性がまだ定義されていません。",
      "validationRequired": "ラベルとキーは必須です。",
      "validationInvalidKey": "属性キーが無効です。小文字のスネークケース（英数字とアンダースコア）のみ使用できます。'.' を含めたり '$' で始めたりできません。",
      "loadError": "ペルソナ属性の読み込みに失敗しました。",
      "saveSuccess": "ペルソナ属性を保存しました。",
      "saveError": "ペルソナ属性の保存に失敗しました。",
      "systemAttributeLocked": "これはデフォルト属性のため、編集・削除はできません。",
      "attributeNotDeletable": "この属性は削除できないよう設定されています。",
      "duplicateOrderError": "重複した順序の値があります: {orders}。各属性には一意の順序が必要です。",
      "duplicateAliasKeyError": "「{first}」と「{second}」は同じ属性を指します（例: income と annual_income）。重複を削除するか、どちらかのキーを変更してください。",
      "invalidOrderRangeError": "属性の順序が無効です。順序は1から属性の総数までの連番である必要があります。",
      "dragReorderHint": "ハンドルをドラッグして属性を並べ替えます。",
      "dragHandle": "ドラッグして並べ替え",
      "attributeCount": "{count} 件の属性"
    },
    "personavalidation": {
      "mustBeNumber": "有効な数値を入力してください",
      "valueMustBeAtLeast": "{min}以上の値を入力してください",
      "valueMustBeAtMost": "{max}以下の値を入力してください",
    },
    "personaedit": {
      "title": "ペルソナを編集",
      "description": "このペルソナの属性を更新します。変更は既存のペルソナに保存されます。",
      "backToPersonaManagement": "ペルソナ管理に戻る",
      "notFound": "このペルソナが見つかりませんでした。削除された可能性があります。",
      "changeImage": "画像を変更",
      "personaPreview": "ペルソナプレビュー",
      "unnamedPersona": "名前未設定のペルソナ",
      "activeServicesPlaceholder": "サービスを追加して Enter キーを押してください",
      "fieldRequired": "この項目は必須です。",
      "fields": {
        "first_name": "名",
        "last_name": "姓",
        "age": "年齢",
        "country": "国",
        "interests": "興味・関心",
        "marital_status": "婚姻状況",
        "gender": "性別",
        "number_of_children": "子どもの数",
        "education_level": "学歴",
        "job_title": "職種",
        "annual_income": "年収",
        "preferred_contact_method": "希望連絡方法",
        "payment_terms": "支払条件",
        "area": "地域",
        "current_operator": "現在の通信事業者",
        "plan_type": "料金プラン",
        "active_services": "利用中のサービス",
        "data_usage": "データ使用量",
        "average_monthly_spend": "平均月額利用料",
        "churn_propensity": "解約リスク"
      }
    },
    "personainfo": {
      "generatedPersona": "生成済みペルソナ",
      "backToPersonas": "ペルソナ一覧に戻る",
      "personalProfile": "プロフィール",
      "demographics": "基本属性",
      "personality": "性格",
      "personalInterests": "関心",
      "devices": "デバイス",
      "telecomProfile": "通信サービス利用状況",
      "bigFivePersonalityProfile": "Big5性格特性",
      "weekendRoutine": "週末の過ごし方",
      "onlineBehavior": "オンライン行動",
      "connectionUsage": "通信利用状況",
      "transportationBehaviour": "移動手段の利用状況",
      "workPatternsAndUsage": "働き方と利用状況",
      "mainNeeds": "主なニーズ",
      "technologyAndTools": "テクノロジーとツール",
      "customerStatus": "顧客ステータス",
      "customerEngagement": "顧客エンゲージメント",
      "energyUsageContext": "エネルギー利用状況",
      "onlineBehaviorAndEnergyEngagement": "オンライン行動とエネルギー関連への関心",
      "characterProfile": "キャラクタープロフィール"
    },
    "promptmanagement": {
      "title": "プロンプト管理",
      "description": "インタビューやフォーカスグループで使用するプロンプトを管理・整理します。",
      "questionDriven": "質問ベース",
      "questionDrivenDescription": "インタビューやフォーカスグループで使用するカスタム質問を作成・管理します。",
      "templateBased": "テンプレートベース",
      "templateBasedDescription": "さまざまな目的やシナリオに応じた定型テンプレートを使用・管理します。",
      "backToPromptManagement": "プロンプト管理に戻る",
      "newPrompt": "新規プロンプト",
      "editPrompt": "プロンプトを編集",
      "createPrompt": "プロンプトを作成",
      "allTypes": "すべてのタイプ",
      "promptType": "プロンプトタイプ",
      "selectPromptType": "プロンプトタイプを選択",
      "promptName": "プロンプト名",
      "enterPromptName": "プロンプト名を入力",
      "promptContent": "プロンプトの内容",
      "enterPromptContent": "プロンプトの内容を入力",
      "columnPromptName": "プロンプト名",
      "columnPreview": "プレビュー",
      "loadingPrompts": "プロンプトを読み込んでいます…",
      "noPromptsAvailable": "利用可能なプロンプトはありません。",
      "deletePromptTitle": "プロンプトを削除",
      "confirmDeleteNamed": "{name}を削除してもよろしいですか？この操作は取り消せません。",
      "promptUpdatedSuccess": "プロンプトを更新しました。",
      "promptAddedSuccess": "プロンプトを追加しました。",
      "promptDuplicatedSuccess": "プロンプトを複製しました。",
      "copyOfName": "{name}のコピー",
      "questionGenerationType": "質問生成",
      "summariseType": "サマリー"
    },
    "promptmanagementquestiondriven": {
      "title": "質問ベースのフォーカスグループ・プロンプト管理",
      "description": "質問ベースのフォーカスグループの実行で使用するプロンプトを管理します。"
    },
    "promptmanagementtemplates": {
      "title": "テンプレートベースのフォーカスグループ・プロンプト管理",
      "description": "テンプレートベースのフォーカスグループ実行で使用するミーティングテンプレートと出力プロンプトを管理します。",
      "newMeetingTemplate": "新規ミーティングテンプレート",
      "meetingTemplateManagement": "ミーティングテンプレート管理",
      "meetingTemplateManagementHint": "ステップ単位のファシリテーター制御プロンプトを含むミーティングテンプレートを作成・管理します。",
      "availableMeetingTemplates": "利用可能なミーティングテンプレート",
      "loadingTemplates": "テンプレートを読み込んでいます…",
      "noTemplatesAvailable": "利用可能なテンプレートはありません。",
      "columnTemplateName": "テンプレート名",
      "columnLastUpdated": "更新日時",
      "deleteTemplateTitle": "テンプレートを削除",
      "outputPromptManagement": "出力プロンプト管理",
      "outputPromptManagementHint": "テンプレートベースのフォーカスグループで使用する出力プロンプトを作成・管理します。",
      "backToTemplateList": "テンプレート一覧に戻る",
      "editTemplate": "テンプレートを編集",
      "notes": "メモ",
      "templateSteps": "テンプレートのステップ",
      "promptText": "プロンプトテキスト",
      "noStepsView": "このテンプレートにはステップが定義されていません。",
      "editMeetingTemplate": "ミーティングテンプレートを編集",
      "basicInformation": "基本情報",
      "enterTemplateName": "テンプレート名を入力",
      "optionalLabel": "（任意）",
      "enterNotes": "メモを入力",
      "templateStepsHint": "各ステップの順序とプロンプトを設定します。プロンプトはフォーカスグループの実行中にそれぞれ個別に適用されます。",
      "addStep": "ステップを追加",
      "stepName": "ステップ名",
      "enterStepName": "ステップ名を入力",
      "enterPromptText": "プロンプトテキストを入力",
      "noStepsEdit": "ステップがまだ定義されていません。",
      "atLeastOneStepRequired": "保存する前に少なくとも1つのステップが必要です。",
      "fillRequiredFieldsStar": "続行するには、*が付いている必須項目を入力してください。",
      "saveTemplate": "テンプレートを保存",
      "deleteStepTitle": "ステップを削除",
      "deleteStepConfirm": "ステップ{order}を削除してもよろしいですか？この操作は取り消せません。",
      "deleteStepConfirmNamed": "ステップ{order}「{name}」を削除してもよろしいですか？この操作は取り消せません。",
      "leavePageTitle": "ページを離れますか？",
      "leavePageConfirm": "テンプレートベースのプロンプト管理ページに移動します。よろしいですか？変更内容は保存されません。",
      "stay": "留まる",
      "leave": "移動する",
      "templateSavedSuccess": "テンプレートを保存しました。",
      "showAttachment": "参加者に資料を表示",
      "stimulusMaterialHelp": "提示資料（画像、PDF、PowerPointファイル）を付けてフォーカスグループを開始した場合、このスイッチで、そのステップ中にペルソナとファシリテーターがすべての資料を見られるかどうかを決めます。",
      "stimulusMaterialHelpBias": "ウォームアップや自発的な回答を求めるステップではオフにしてください。資料を見ると回答が影響を受けます。",
      "stimulusMaterialHelpCost": "資料の各ページは、資料を表示するステップのすべてのモデル呼び出しで送信されるため、それらのステップのコストが増えます。",
      "attachmentShown": "資料表示あり",
      "attachmentHidden": "資料表示なし"
    },
    "attachmentpreview": {
      "kindImage": "画像",
      "kindPdf": "PDF",
      "kindPptx": "PowerPoint",
      "pageCount": "{count} ページ",
      "page": "{page} ページ目",
      "openPage": "{page} ページ目を新しいタブで開く",
      "loadingPreview": "プレビューを読み込み中...",
      "previewUnavailable": "プレビューを表示できません。",
      "previewUnavailableWithReason": "プレビューを表示できません: {reason}",
      "materialPosition": "資料 {position}/{total}: {name}"
    },
    "sidebar": {
      "personas": "ペルソナ",
      "chat": "チャット",
      "interviewPersonas": "ペルソナインタビュー",
      "focusGroup": "フォーカスグループ",
      "dashboard": "ダッシュボード",
      "generatePersonas": "ペルソナ作成",
      "personaManagement": "ペルソナ管理",
      "promptManagement": "プロンプト管理"
    },
    "snacks": {
      "downloaded": "ダウンロードしました",
      "formatFileNotSupportedAllowedFormatJpgPngJpegPptx": "このファイル形式はサポートされていません。利用可能な形式: .jpg、.png、.jpeg、.pptx"
    },
    "chat": {
      "confirmDeletion": "削除の確認",
      "areYouSureYouWantToDeleteThisConversationThisActionCannotBeUndone": "この会話を削除してもよろしいですか？この操作は取り消せません。",
      "chatWithPersonas": "ペルソナとチャット",
      "personaSelection": "ペルソナ選択",
      "conversations": "会話",
      "noConversationsYet": "会話はまだありません",
      "selectAPersonaAndStartChatting": "ペルソナを選択してチャットを開始してください",
      "loadingConversations": "会話を読み込んでいます…",
      "selectAPersona": "ペルソナを選択",
      "startANewConversation": "新しい会話を開始",
      "noConversationSelected": "会話が選択されていません",
      "noMessagesYet": "メッセージはまだありません",
      "startAConversationBySendingAMessage": "メッセージを送信して会話を開始してください",
      "page": "ページ",
      "slide": "スライド",
      "typeYourMessageHere": "ここにメッセージを入力…",
      "pleaseSelectAPersonaToStartChatting": "チャットを開始するにはペルソナを選択してください",
      "conversationDeletedSuccessfully": "会話を削除しました。",
      "failedToDeleteConversation": "会話を削除できませんでした。",
      "failedToLoadConversations": "会話を読み込めませんでした。",
      "failedToLoadPersonas": "ペルソナを読み込めませんでした。",
      "failedToLoadConversationMessages": "会話メッセージを読み込めませんでした。",
      "pleaseSelectAPersona": "ペルソナを選択してください。",
      "pleaseEnterAQuestion": "質問を入力してください。",
      "noResponse": "応答がありません。",
      "failedToGetAResponse": "応答を取得できませんでした。",
      "failedToGetResponseFromPersona": "ペルソナからの応答を取得できませんでした。",
      "failedToGenerateANewThreadID": "新しいスレッドIDを生成できませんでした。",
      "failedToLoadDataPleaseTryAgainLater": "データを読み込めませんでした。後でもう一度お試しください。"
    },
    "personaFields": {
      "age": "年齢",
      "gender": "性別",
      "occupation": "職業",
      "civil_status": "婚姻状況",
      "geographic_area_of_residence": "居住地域",
      "qualification": "学歴",
      "income": "収入",
      "segments": "セグメント群",
      "segmentation": "セグメント",
      "country": "国",
      "firstName": "名",
      "lastName": "姓",
      "marital_status": "婚姻状況",
      "number_of_children": "子どもの数",
      "education_level": "学歴",
      "job_title": "職種",
      "annual_income": "年収",
      "preferred_contact_method": "希望連絡方法",
      "payment_terms": "支払条件",
      "area": "地域",
      "current_operator": "現在の通信事業者",
      "plan_type": "料金プラン",
      "active_services": "利用中のサービス",
      "data_usage": "データ使用量",
      "average_monthly_spend": "平均月額利用料",
      "churn_propensity": "解約リスク"
    },
    "authentication": {
      "register": "新規登録",
      "createYourSocialSimulationAccount": "アカウントを作成",
      "email": "メールアドレス",
      "username": "ユーザー名",
      "password": "パスワード",
      "confirmPassword": "パスワードを確認",
      "alreadyHaveAnAccount": "すでにアカウントをお持ちですか？",
      "login": "ログイン",
      "accessSocialSimulation": "Social Simulation Platformにアクセス",
      "dontHaveAnAccount": "アカウントをお持ちでないですか？",
      "logout": "ログアウト",
      "fieldIsRequired": "この項目は必須です",
      "invalidEmail": "メールアドレスの形式が正しくありません",
      "usernameMustBeAtLeast3Characters": "ユーザー名は3文字以上で入力してください",
      "passwordMustBeAtLeast8Characters": "パスワードは8文字以上で入力してください",
      "passwordsDoNotMatch": "パスワードが一致しません",
      "registrationCompletedSuccessfully": "登録が完了しました",
      "registrationFailedPleaseTryAgain": "登録に失敗しました。もう一度お試しください。",
      "loginFailedPleaseCheckYourCredentials": "ログインに失敗しました。入力内容をご確認ください。",
      "socialSimulationPlatform": "Social Simulation Platform",
      "aipoweredFocusGroupFacilitationToUnlockDeeperInsights": "AIによるフォーカスグループ支援で、より深いインサイトを引き出します。"
    }
  }
}

const supportedLocales = ['en', 'ja']

function normalizeLocale(locale) {
  if (!locale) return 'en'

  const normalized = locale.toLowerCase()
  if (normalized.startsWith('ja')) {
    return 'ja'
  }
  if (normalized.startsWith('en')) {
    return 'en'
  }
  return 'en'
}


function getDefaultLocale() {
  const savedLanguage = localStorage.getItem('appLanguage')
  const normalizedSavedLanguage = normalizeLocale(savedLanguage)

  if (supportedLocales.includes(normalizedSavedLanguage)) {
    if (savedLanguage !== normalizedSavedLanguage) {
      localStorage.setItem('appLanguage', normalizedSavedLanguage)
    }

    return normalizedSavedLanguage
  }

  const browserLanguages =
    navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language]

  for (const browserLanguage of browserLanguages) {
    const mappedLocale = normalizeLocale(browserLanguage)

    if (supportedLocales.includes(mappedLocale)) {
      return mappedLocale
    }
  }

  return 'en'
}



export default createI18n({
  legacy: false,
  locale: getDefaultLocale(),
  fallbackLocale: 'en',
  messages
})
